import React from 'react';
import {Button, Dimmer} from 'semantic-ui-react';

import './SlideOutLayout.scss';

export default ({
  addTerm,
  children,
  dimmed = false,
  hideButton = false,
  onAdd,
  onHandleReference = null,
  secondaryAction = null,
  title,
  id = 'slideoutlayout',
  loading = false,
}) => (
  <div ref={onHandleReference} className="mhd--full-page" id={id}>
    <Dimmer.Dimmable dimmed={dimmed}>
      <div className="mhd--page--header clearfix">
        <h1>{title}</h1>
        <div className="mhd--page--header-actions">
          {secondaryAction}
          {!hideButton && (
            <Button
              id={`${id}_header_addBtn`}
              loading={loading}
              onClick={onAdd}
              primary
              style={{marginRight: 15, marginLeft: 8}}
              type="button"
            >
              <i className="zmdi zmdi-plus" />
              &nbsp; Add {addTerm}
            </Button>
          )}
        </div>
      </div>

      <div style={{margin: 30}}>{children}</div>
    </Dimmer.Dimmable>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Common/Structure/SlideOutLayout.js